<template>
  <ed-input-item :label="label" :info="info" :name="name" :required="required">
    <template v-if="isRadio">
      <div class="el-input">
        <div
          class="form-check col-12 text-left pl-0"
          v-for="(item, index) in items"
          :key="index"
        >
          <input
            type="radio"
            :checked="value == item.id ? 'checked' : ''"
            :value="value"
            :name="name"
            :id="name+'_'+item.id"
            :disabled="disabled || disabledItem(item)"
            @change="setEvent('input', this.isObject ? item : item.id)"
          />
          <label class="form-check-label" :for="name+'_'+item.id">
            {{ item.descricao }}
          </label>

          <div class="mb-2" v-if="!!$slots[name+'_'+item.id]" style="background: #ffdbdb;">
            <slot :name="name+'_'+item.id"/>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <el-select
        :value="value"
        :clearable="clearable"
        :loading="loading"
        :placeholder="placeholder"
        :disabled="disabled"
        :multiple="multiple"
        :value-key="valueKey"
        @change="setEvent('input', $event)"
        collapse-tags
        filterable
      >
        <el-option
          v-for="(item, index) in items"
          :key="index"
          :label="item.descricao"
          :value="this.isObject ? item : item[valueKey]"
        >
        </el-option>
      </el-select>
    </template>
  </ed-input-item>
</template>

<script>
import EdFormMixin from "./mixins/formControl";
import EdInputItem from "./EdInputItem";

export default {
  name: "EdInputSelectTipo",
  mixins: [EdFormMixin],
  components: { EdInputItem },
  props: {
    tipo: {
      type: [String, Number],
      required: true,
    },
    exclude: {
      type: [Array],
      required: false,
      default: function () {
        return [];
      },
    },
    isObject: {
      type: [Boolean],
      required: false,
      default: false,
    },
    isRadio: {
      type: [Boolean],
      required: false,
      default: false,
    },
  },
  data() {
    return {
      items: [],
      loadingTipo: false,
    };
  },
  beforeDestroy() {},
  created() {},
  mounted() {
    this.getTipo();
  },
  computed: {},
  methods: {

    getTipo() {
      if (!this.tipo) return;

      this.items = [];
      this.loadingTipo = true;

      this.$root.$request
        .post("tipo/parent", {
          codigo: [this.tipo],
          exclude: this.exclude,
        })
        .then((result) => {
          this.loadingTipo = false;
          if (result.status == 200) {
            this.items = result.data[this.tipo];
          }
        });
    },
  },
  watch: {
    tipo() {
      this.getTipo();
    },
  },
};
</script>



// WEBPACK FOOTER //
// EdInputSelectTipo.vue?f879ba52